import React from "react";
import history from "../routes/history"
import { connect } from "react-redux";
import { fetchLottoConfig } from "../store/config/action";
import { fetchUserProfile } from "../store/user/action";
import { storage, STORAGE_KEYS } from "../utils/storage";
import { getRedirectNoAuth } from "../constants/general";

export default (WrappedComponent, appClass) => {

    class WithAuth extends React.Component {

        componentDidMount() {
            const accessToken = storage.get(STORAGE_KEYS.accessToken);
            const isNotEnter = JSON.parse(localStorage.getItem("isNotEnter"))?.isNotEnter;
            if (accessToken === "" || accessToken === null || accessToken === undefined) {
                if (isNotEnter) {
                    history.push("/not-found")
                } else {
                    history.push(getRedirectNoAuth);
                }
                return;
            }
            this.props.fetchLottoConfig();
            this.props.fetchUserProfile();
        }

        render() {
            const accessToken = storage.get(STORAGE_KEYS.accessToken);

            if (accessToken === "" || accessToken === null || accessToken === undefined) {
                return null
            } else {
                return (<WrappedComponent {...this.props} appClass={appClass} />)
            }
        }
    }

    const mapStateToProps = state => ({})

    return connect(mapStateToProps, { fetchLottoConfig, fetchUserProfile })(WithAuth)
}
